var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { cx } from 'emotion';
import { deprecatedProp as deprecated } from './utils';
export default class ButtonGroup extends PureComponent {
    render() {
        const _a = this.props, { type, variant, className } = _a, rest = __rest(_a, ["type", "variant", "className"]);
        return React.createElement("div", Object.assign({ className: cx(`btn-group btn-group-${variant || type || 'justified'}`, className) }, rest), this.props.children);
    }
}
ButtonGroup.propTypes = {
    variant: PropTypes.oneOf(['justified', 'vertical']),
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
    className: PropTypes.string,
    type: deprecated(PropTypes.oneOf(['justified', 'vertical']), 'Use `variant` instead.'),
};
